module.exports = __webpack_public_path__ + "img/成就未来数字人才.efb40be9.png";